import React, { Component } from 'react'
import { Header, Columns } from '../../elements'
import moment from 'moment'
import {
  CLOUDINARY_NAME,
  CLOUDINARY_API_KEY,
} from '../../../constants/images/cloudinary'
import cloudinary from 'cloudinary-core'
import ProgressiveImage from 'components/elements/progressiveImages'
import { Link } from "react-router-dom"

const cl = new cloudinary.Cloudinary({
  cloud_name: CLOUDINARY_NAME,
  api_key: CLOUDINARY_API_KEY,
})
class BlogCard extends Component {

  truncateSentence(sentence, maxWords) {
    const words = sentence.split(' ');
    if (words.length > maxWords) {
      return words.slice(0, maxWords).join(' ') + '... '
    }
    return sentence + " "
  }

  render() {
    const { post, key, showSummary, isMobile } = this.props
    return (
      <Columns.Column size={4} key={key} className={`${isMobile && showSummary ? 'mb-5' : 'mb-6'}`}>
        <div className="is-relative">
          <a href={`/blog/posts/${post.slug}`}>
            <ProgressiveImage
              overlaySrc={cl.url(post.featured_image, {
                gravity: 'center',
                height: 2,
                width: 3,
                crop: 'fill',
                format: 'jpg',
                type: 'fetch',
              })}
              src={cl.url(post.featured_image, {
                gravity: 'center',
                height: 200,
                width: 345,
                crop: 'fill',
                format: 'jpg',
                type: 'fetch',
                quality: 80,
              })}
              alt={post.title}
              style={{ width: '100%' }}
              className="has-rounded-corners"
            />
          </a>
          <div className="blog-meta-data">
            <span className="is-size-7 is-block has-text-weight-bold mb-2 mt-2">
              {moment(post.published).format('MMMM D, YYYY')}
            </span>
          </div>
          <a href={`/blog/posts/${post.slug}`}>
            <h3 className="has-text-weight-medium title is-5">
              {post.title}
            </h3>
          </a>
          {showSummary && (
            <Link to={`/blog/posts/${post.slug}`}>
              <div className="has-text-dark mt-2">
                {this.truncateSentence(post.summary, 20)}
                <Link to={`/blog/posts/${post.slug}`}>Read Now &gt;&gt;</Link>
              </div>
            </Link>
          )}
        </div>
      </Columns.Column>
    )
  }
}

export default BlogCard
BlogCard.defaultProps = {
  headerLevel: 'h2',
}
